
export const wisdomToothData = {
  faqs: [
    {
      question: "When should wisdom teeth be removed?",
      answer: "Wisdom teeth typically need removal when they cause pain, infection, damage to adjacent teeth, cysts, or when they become impacted (unable to fully emerge through the gums). At Asrani Dental in Sadar, Nagpur, we recommend regular check-ups to monitor wisdom teeth development and determine if extraction is necessary."
    },
    {
      question: "Is wisdom tooth removal painful?",
      answer: "At Asrani Dental Clinic in Nagpur, we perform wisdom tooth extractions under local anesthesia, ensuring you're comfortable throughout the procedure. While you might feel pressure during the extraction, you shouldn't feel pain. After the procedure, some discomfort and swelling are normal but can be managed with prescribed medications."
    },
    {
      question: "How long is the recovery period after wisdom tooth extraction?",
      answer: "Most patients recover from wisdom tooth extraction within 3-5 days. Complete healing of the extraction site takes about 1-2 weeks. Our team at Asrani Dental, Sadar provides detailed after-care instructions to ensure a smooth recovery with minimal discomfort."
    },
    {
      question: "What should I eat after wisdom tooth removal?",
      answer: "In the first 24-48 hours after extraction at our Nagpur clinic, we recommend soft foods like yogurt, pudding, applesauce, and lukewarm soups. As healing progresses, you can gradually introduce semi-soft foods. Avoid hard, crunchy, or spicy foods, as well as using straws which can dislodge blood clots and cause dry socket."
    },
    {
      question: "What are the risks of keeping problematic wisdom teeth?",
      answer: "Keeping problematic wisdom teeth can lead to various complications including pain, infection, damage to adjacent teeth, gum disease, tooth decay, and cyst formation. In some cases, impacted wisdom teeth can cause crowding of other teeth. At Asrani Dental in Nagpur, we thoroughly evaluate each case to determine the best course of action."
    }
  ],
  testimonials: [
    {
      name: "Vikram Joshi",
      comment: "I had been experiencing severe pain from an impacted wisdom tooth for weeks. The team at Asrani Dental in Sadar, Nagpur made the extraction process smooth and virtually painless. Their aftercare instructions were clear, and they followed up to check on my recovery. I'm grateful for their expertise and care.",
      rating: 5
    },
    {
      name: "Shalini Gupta",
      comment: "I was extremely anxious about having all four wisdom teeth removed, but Dr. Asrani at his Nagpur clinic was patient and reassuring. They thoroughly explained the procedure, answered all my questions, and made sure I was comfortable. Recovery was much easier than I expected with their excellent guidance.",
      rating: 5
    },
    {
      name: "Rohan Mehta",
      comment: "After years of on-and-off pain from my wisdom teeth, I finally visited Asrani Dental Clinic in Nagpur. I wish I had gone sooner! The extraction was quick, professional, and the relief was immediate. Their post-operative care was exceptional, and the entire team showed genuine concern for my comfort.",
      rating: 5
    }
  ],
  services: [
    {
      title: "Simple Extraction",
      description: "Removal of fully erupted wisdom teeth that are visible in the mouth and can be extracted using conventional techniques.",
      backgroundColor: "bg-white",
    },
    {
      title: "Surgical Extraction",
      description: "Specialized procedure for impacted wisdom teeth that haven't fully erupted or are positioned at difficult angles in the jawbone.",
      backgroundColor: "bg-[#F5F2EE]",
    },
    {
      title: "Partial Extraction",
      description: "In certain complex cases, a coronectomy (partial removal) may be performed to avoid damage to nearby nerves and structures.",
      backgroundColor: "bg-[#E5DEFF]",
    },
    {
      title: "Wisdom Tooth Assessment",
      description: "Comprehensive evaluation including X-rays and 3D imaging to determine if and when wisdom tooth removal is necessary.",
      backgroundColor: "bg-[#F7F5FF]",
    },
    {
      title: "Sedation Options",
      description: "Various sedation levels available for anxious patients or complex cases to ensure maximum comfort during the procedure.",
      backgroundColor: "bg-[#EEFBF3]",
    },
    {
      title: "Post-Extraction Care",
      description: "Complete aftercare including pain management, infection prevention, and guidance for optimal healing of the extraction site.",
      backgroundColor: "bg-[#FFF8F0]",
    }
  ],
  benefits: [
    {
      title: "Painless Procedure",
      description: "Advanced anesthesia techniques ensure your comfort throughout the extraction process."
    },
    {
      title: "Experienced Specialists",
      description: "Our team in Nagpur has extensive experience with both simple and complex wisdom tooth extractions."
    },
    {
      title: "Preventive Approach",
      description: "Early removal of problematic wisdom teeth prevents future complications and protects adjacent healthy teeth."
    },
    {
      title: "Comprehensive Care",
      description: "From evaluation through recovery, we provide complete care and detailed aftercare instructions."
    }
  ],
  relatedServices: [
    { name: "General Dentistry", path: "/services/general-dentistry-in-nagpur" },
    { name: "Painless RCT", path: "/services/painless-rct-in-nagpur" },
    { name: "Dental Implants", path: "/services/dental-implants-in-nagpur" },
    { name: "Cosmetic Dentistry", path: "/services/cosmetic-dentistry" },
    { name: "Orthodontics", path: "/services/orthodontics-in-nagpur" }
  ]
};
